<template>
  <button
    type="button"
    class="option-row"
    :class="{ 'option-row--selected': selected, 'option-row--locked': locked }"
    :aria-pressed="selected ? 'true' : 'false'"
    :disabled="locked"
    @click="$emit('pick')"
  >
    <span
      v-if="marked"
      class="option-row__mark"
      :class="{ 'option-row__mark--multi': multi }"
      aria-hidden="true"
    >
      <i v-if="selected" :class="multi ? 'fas fa-check' : 'fas fa-circle'"></i>
    </span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "OptionRow",
  props: {
    selected: { type: Boolean, default: false },
    multi: { type: Boolean, default: false },
    locked: { type: Boolean, default: false },
    /** Lead with a radio or a check box; a row that shows its own mark turns this off. */
    marked: { type: Boolean, default: true },
  },
  emits: ["pick"],
};
</script>

<style lang="scss" scoped>
.option-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 44px;
  padding: 8px 10px;
  border: 1px solid rgba(127, 127, 127, 0.25);
  border-radius: 10px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;

  &:hover:not(:disabled) {
    background: rgba(127, 127, 127, 0.08);
  }

  &:focus-visible {
    outline: 2px solid var(--oliver-accent);
    outline-offset: 2px;
  }

  &--selected,
  &--selected:hover:not(:disabled) {
    border-color: var(--oliver-accent);
    background: var(--oliver-indicator-bg);
  }

  &--locked {
    cursor: default;
    opacity: 0.7;
  }
}

.option-row__mark {
  flex: 0 0 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid rgba(127, 127, 127, 0.55);
  border-radius: 50%;
  font-size: 7px;
  color: #fff;

  &--multi {
    border-radius: 5px;
    font-size: 10px;
  }

  .option-row--selected & {
    border-color: var(--oliver-accent);
    background: var(--oliver-accent);
  }
}
</style>
